export default "__VITE_ASSET__9bAB2wJ$__"